import { branding } from "../config/branding";
import { WORKFLOW_CONFIG, Workflow } from "../config/workflowConfig";

interface WelcomePanelProps {
  workflow: Workflow;
  onExampleClick: (query: string) => void;
}

export function WelcomePanel({ workflow, onExampleClick }: WelcomePanelProps) {
  const cfg = WORKFLOW_CONFIG[workflow];

  return (
    <div className="mx-auto max-w-2xl px-4 py-12 text-center">
      <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-accent/20 to-brand-navy/10 shadow-inner">
        <span className="text-3xl font-bold text-brand-navy">{cfg.label.charAt(0)}</span>
      </div>
      <h2 className="text-2xl font-bold text-brand-navy">{cfg.label}</h2>
      <p className="mt-2 text-gray-600">{cfg.description}</p>
      <p className="mt-1 text-sm text-gray-400">{branding.tagline}</p>

      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        {branding.exampleQueries.slice(0, 4).map((q) => (
          <button
            key={q}
            type="button"
            onClick={() => onExampleClick(q)}
            className="rounded-xl border border-gray-200 bg-white px-4 py-3 text-left text-sm text-gray-700 shadow-sm transition hover:border-brand-accent hover:shadow-md"
          >
            <span className="text-brand-accent">→</span> {q}
          </button>
        ))}
      </div>
    </div>
  );
}
